import React from "react"
import {
    Container,
    Col,
    Row} from 'reactstrap';
    import logoblue from './images/logoblue.png'
    import facebook from './images/facebook.png'
    import twitter from './images/twitter.png'
    import whatsapp from './images/whatsapp.png'
function Homepage(){
    return(
        <div>
            <Container fluid className="fullscreen homepage">
            <Row className="openclass align-items-left">
                <Col className="text-left">
                <a href="https://aljazeera.com" target="_blank">
                <p className="toplogo"><img alt="Al Jazeera"  width="110px" height="auto" src={logoblue}/></p>
                </a>
                <h1 className="display-1 mainhead">DEATH FROM ABOVE</h1>
                <h2 className="display-3 subhead georgia">Every Saudi coalition air raid on Yemen</h2>
                <br/>
                <p className="datehead"><small><strong>Last updated:</strong> 25 March 2019</small></p>
                </Col>
            </Row>
            <Row className="align-items-left">
            </Row>
            <Row className="align-items-end">
            {/* <p className="ajlabs">@AJLABS</p> */}
            </Row>
            
            </Container>
        </div>
    )
}
export default Homepage
